export const mediumBreakpoint = 992;
export const smallBreakpoint = 768;
export const xsBreakpoint = 576;
